// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.
/**
 * Turbo-aware fetch utilities
 * @gem rapid_rails_ui
 *
 * Shared helpers for CSRF-protected fetch requests with automatic
 * Turbo Stream response handling. Used by any Stimulus controller
 * that needs to persist data to a Rails backend.
 *
 * Usage:
 *   import { turboFetch, handleTurboStream } from "./shared/turbo_fetch"
 *
 *   const response = await turboFetch("/items/1", {
 *     method: "PATCH",
 *     headers: { "Content-Type": "application/json" },
 *     body: JSON.stringify({ name: "new" })
 *   })
 *   if (response.ok) await handleTurboStream(response)
 */

/**
 * Read the Rails CSRF token from the meta tag.
 * @returns {string}
 */
export function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content ?? ""
}

/**
 * Fetch with automatic CSRF token and Turbo-compatible Accept header.
 * Returns the raw Response — callers handle success/error themselves.
 *
 * @param {string} url
 * @param {RequestInit} options — merged with CSRF/Accept defaults
 * @returns {Promise<Response>}
 */
export async function turboFetch(url, options = {}) {
  const { headers = {}, ...rest } = options

  return fetch(url, {
    headers: {
      "Accept": "text/vnd.turbo-stream.html, text/html, application/json",
      "X-CSRF-Token": getCsrfToken(),
      ...headers
    },
    ...rest
  })
}

/**
 * If the response is a Turbo Stream, render it and return true.
 * Otherwise return false (body unconsumed — caller can still read it).
 *
 * @param {Response} response
 * @returns {Promise<boolean>}
 */
export async function handleTurboStream(response) {
  const contentType = response.headers.get("content-type") ?? ""
  if (contentType.includes("turbo-stream") && typeof Turbo !== "undefined") {
    Turbo.renderStreamMessage(await response.text())
    return true
  }
  return false
}
